import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 items-start pl-4 py-4 xl:py-6 min-w-[233px] max-w-[233px] bg-white border-l border-ternary overflow-y-auto xl:max-h-[calc(100vh-64px)] max-h-[calc(100vh-56px)] select-none" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex items-center justify-between gap-2 min-h-9"
}
const _hoisted_3 = { class: "text-black text-sm text-left break-all" }
const _hoisted_4 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_5 = { class: "text-brown text-sm text-left" }
const _hoisted_6 = { class: "flex flex-col gap-3" }
const _hoisted_7 = { class: "flex items-center justify-between gap-1" }
const _hoisted_8 = { class: "text-brown text-sm" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "flex items-center justify-between gap-1" }
const _hoisted_11 = { class: "text-brown text-sm text-left" }
const _hoisted_12 = { class: "flex items-center justify-between gap-1" }
const _hoisted_13 = { class: "text-brown text-sm" }
const _hoisted_14 = { class: "flex flex-col gap-1" }
const _hoisted_15 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex flex-col gap-2 items-start" }
const _hoisted_18 = { class: "font-bold text-base leading-[20px] text-black" }
const _hoisted_19 = { class: "flex flex-col gap-2 items-start" }
const _hoisted_20 = { class: "font-bold text-base leading-[20px] text-black" }
const _hoisted_21 = { class: "block text-left font-normal text-sm text-brown ml-2" }
const _hoisted_22 = { class: "text-left font-normal text-sm text-brown ml-2" }
const _hoisted_23 = { class: "text-left font-normal text-sm text-brown ml-2" }
const _hoisted_24 = { class: "text-left font-normal text-sm text-brown ml-2" }
const _hoisted_25 = { class: "text-center whitespace-pre-line" }
const _hoisted_26 = { class: "text-left font-normal text-sm text-brown ml-2 w-[120px]" }
const _hoisted_27 = { class: "text-left font-normal text-sm text-brown ml-2 w-[120px]" }
const _hoisted_28 = { class: "w-full" }
const _hoisted_29 = { class: "text-brown text-sm text-left" }
const _hoisted_30 = { class: "flex flex-col gap-2 items-start" }
const _hoisted_31 = { class: "font-bold text-base leading-[20px] text-black" }
const _hoisted_32 = { class: "w-full flex gap-2 justify-between" }
const _hoisted_33 = { class: "flex gap-2" }
const _hoisted_34 = { class: "font-semibold text-2xl text-black" }
const _hoisted_35 = { class: "text-left text-base leading-[20px] text-brown whitespace-pre-line" }

import { ref } from "vue";
import { useI18n } from "vue-i18n";
import CancelIcon from "@/components/icons/CancelIcon.vue";
import CustomSlider from "@/components/inputs/CustomSlider.vue";
import CheckBox from "@/components/inputs/CheckBox.vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import { onlyDigits } from "@/utils/validators";
import PrintButton from "@/components/buttons/PrintButton.vue";
import AppSelect from "@/components/inputs/AppSelect.vue";
import MonthShaIcon from "@/components/icons/apartmentPlan/MonthShaIcon.vue";
import YearShaIcon from "@/components/icons/apartmentPlan/YearShaIcon.vue";
import TaiShooIcon from "@/components/icons/apartmentPlan/TaiShooIcon.vue";
import SooiPoIcon from "@/components/icons/apartmentPlan/SooiPoIcon.vue";
import {
  APARTMENT_MONTHS_LIST,
  APARTMENT_MONTHS_VALUES,
  IApartmentMonth,
  MonthKey,
  ToggleKey,
} from "@/constants/apartmentPlan";
import InfoSquareIcon from "@/components/icons/apartmentPlan/InfoSquareIcon.vue";
import AppTooltip from "@/components/AppTooltip.vue";
import ModalComponent from "@/components/ModalComponent.vue";
import VideoInstructionButton from "@/views/Calculators/ApartmentPlan/components/VideoInstructionButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionsComponent',
  props: {
    hasDiagramDate: { type: Boolean },
    imageName: {},
    scale: {},
    diagramScale: {},
    azm: {},
    facadeDirection: {},
    addPointMode: { type: Boolean },
    movePointMode: { type: Boolean },
    removePointMode: { type: Boolean },
    toggles: {}
  },
  emits: ["select-image", "clear-image", "update:scale", "update:diagram-scale", "update:azm", "update:buildYear", "update:starsYear", "update:buildMonth", "changeFacadeDirection", "toggle:move-image", "toggle:add-point", "toggle:move-point", "toggle:remove-point", "toggle:lo-shoo", "toggle:sectors-diagram", "toggle:middle-12-mountains", "toggle:border-12-mountains", "toggle:move-mountains-labels", "export-as-png", "export-as-pdf", "print", "toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

const facadeDirections = [
  { angle: 90, iconClass: "rotate-45" },
  { angle: 180, iconClass: "rotate-[135deg]" },
  { angle: 0, iconClass: "-rotate-45" },
  { angle: 270, iconClass: "-rotate-[135deg]" },
];

const showInfoModal = ref<boolean>(false);
const modalType = ref<"noble-stars" | "current-stars">();

function blockInvalidKeys(e: KeyboardEvent) {
  const invalid = ["e", "E", "+"];
  if (invalid.includes(e.key)) e.preventDefault();
}

function validateBuildYear(e: KeyboardEvent) {
  if (!onlyDigits(e.key, e.ctrlKey)) {
    e.preventDefault();
  }
}

function updateAzmValue(e: Event) {
  const target = e.target as HTMLInputElement;
  let value = Number(target.value);
  if (value < -360) {
    value = -360;
  } else if (value > 360) {
    value = 360;
  }
  emit("update:azm", value);
}

function updateBuildYearValue(e: Event) {
  const buildYear = getYearFromEvent(e);
  if (buildYear !== null) {
    emit("update:buildYear", buildYear);
  }
}

function updateStarsYearValue(e: Event) {
  const starsYear = getYearFromEvent(e);
  if (starsYear !== null) {
    emit("update:starsYear", starsYear);
  }
}

function getYearFromEvent(e: Event) {
  const target = e.target as HTMLInputElement;
  if (target.value.length < 4) {
    return null;
  }
  return Number(target.value);
}

function openInfoModal(openModalType: "noble-stars" | "current-stars") {
  modalType.value = openModalType;
  showInfoModal.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VideoInstructionButton),
    (__props.imageName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.imageName), 1),
          _createElementVNode("button", {
            class: "w-6 h-6 rounded-full border border-black flex items-center justify-center flex-shrink-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clear-image')))
          }, [
            _createVNode(CancelIcon, { class: "text-black" })
          ])
        ]))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "shrink-0 h-9 w-full rounded-[100px] border border-brown text-sm text-brown",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('select-image')))
        }, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.file-select")), 1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.scale")), 1),
      _createVNode(CustomSlider, {
        "model-value": props.scale,
        min: 0.1,
        max: 3,
        step: 0.01,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = (val) => emit('update:scale', val))
      }, null, 8, ["model-value"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.azm-facade")), 1),
        _createElementVNode("input", {
          id: "azm",
          type: "number",
          min: "-360",
          max: "360",
          class: "num-input",
          value: props.azm,
          onKeydown: blockInvalidKeys,
          onInput: updateAzmValue
        }, null, 40, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.build-year")), 1),
        _createElementVNode("input", {
          id: "buildYear",
          type: "text",
          class: "num-input",
          maxlength: "4",
          autocomplete: "off",
          onKeydown: validateBuildYear,
          onInput: updateBuildYearValue
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.stars-year")), 1),
        _createElementVNode("input", {
          id: "tarsYear",
          type: "text",
          class: "num-input",
          maxlength: "4",
          autocomplete: "off",
          onKeydown: validateBuildYear,
          onInput: updateStarsYearValue
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-brown text-sm text-left" }, "Месяц постройки:", -1)),
        _createVNode(AppSelect, {
          items: _unref(APARTMENT_MONTHS_LIST),
          "default-value": _unref(APARTMENT_MONTHS_LIST)[0],
          onSelectOption: _cache[3] || (_cache[3] = (selectedMonth) => emit('update:buildMonth', _unref(APARTMENT_MONTHS_VALUES)[selectedMonth]))
        }, {
          option: _withCtx(({ item }) => [
            _createTextVNode(_toDisplayString(_unref(t)(`months.${item}`)), 1)
          ]),
          _: 1
        }, 8, ["items", "default-value"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[27] || (_cache[27] = _createElementVNode("p", { class: "col-span-2 text-brown text-sm text-left" }, " Направление фасада: ", -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(facadeDirections, (facadeDirection) => {
          return _createElementVNode("button", {
            key: facadeDirection.angle,
            class: _normalizeClass(["facade-direction-button", 
            facadeDirection.angle === props.facadeDirection
              ? 'pointer-events-none facade-direction-button-selected'
              : 'facade-direction-button-active'
          ]),
            onClick: ($event: any) => (emit('changeFacadeDirection', facadeDirection.angle))
          }, [
            _createVNode(ArrowIcon, {
              class: _normalizeClass(["text-white", facadeDirection.iconClass])
            }, null, 8, ["class"])
          ], 10, _hoisted_16)
        }), 64))
      ])
    ]),
    _createVNode(CheckBox, {
      "input-id": "move-image",
      label: _unref(t)('calculators.apartment-plan.actions.move-image'),
      onToggle: _cache[4] || (_cache[4] = ($event: any) => (emit('toggle:move-image')))
    }, null, 8, ["label"]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.points-group")), 1),
      _createVNode(CheckBox, {
        "input-id": "add-point",
        label: _unref(t)('calculators.apartment-plan.actions.add-point'),
        isEnabled: props.addPointMode,
        onToggle: _cache[5] || (_cache[5] = ($event: any) => (emit('toggle:add-point')))
      }, null, 8, ["label", "isEnabled"]),
      _createVNode(CheckBox, {
        "input-id": "move-point",
        label: _unref(t)('calculators.apartment-plan.actions.move-point'),
        isEnabled: props.movePointMode,
        onToggle: _cache[6] || (_cache[6] = ($event: any) => (emit('toggle:move-point')))
      }, null, 8, ["label", "isEnabled"]),
      _createVNode(CheckBox, {
        "input-id": "move-point",
        label: _unref(t)('calculators.apartment-plan.actions.remove-point'),
        isEnabled: props.removePointMode,
        onToggle: _cache[7] || (_cache[7] = ($event: any) => (emit('toggle:remove-point')))
      }, null, 8, ["label", "isEnabled"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.nets-group")), 1),
      _createVNode(CheckBox, {
        "input-id": "lo-shoo",
        label: _unref(t)('calculators.apartment-plan.actions.lo-shoo'),
        onToggle: _cache[8] || (_cache[8] = ($event: any) => (emit('toggle', 'lo-shoo')))
      }, null, 8, ["label"]),
      _createVNode(CheckBox, {
        "input-id": "sectors-diagram",
        label: _unref(t)('calculators.apartment-plan.actions.sectors-diagram'),
        isEnabled: __props.toggles['sectors-diagram'],
        onToggle: _cache[9] || (_cache[9] = ($event: any) => (emit('toggle', 'sectors-diagram')))
      }, null, 8, ["label", "isEnabled"]),
      _createVNode(CheckBox, {
        class: "pl-5",
        isDisabled: !__props.hasDiagramDate,
        isEnabled: __props.toggles['tai-shoo'],
        "input-id": "tai-shoo",
        label: _unref(t)('calculators.apartment-plan.actions.tai-shoo'),
        onToggle: _cache[10] || (_cache[10] = ($event: any) => (emit('toggle', 'tai-shoo')))
      }, {
        label: _withCtx(({ label }) => [
          _createVNode(TaiShooIcon, { class: "ml-2" }),
          _createElementVNode("span", _hoisted_21, _toDisplayString(label), 1)
        ]),
        _: 1
      }, 8, ["isDisabled", "isEnabled", "label"]),
      _createVNode(CheckBox, {
        class: "pl-5",
        "input-id": "sui-po",
        isDisabled: !__props.hasDiagramDate,
        isEnabled: __props.toggles['sui-po'],
        label: _unref(t)('calculators.apartment-plan.actions.sui-po'),
        onToggle: _cache[11] || (_cache[11] = ($event: any) => (emit('toggle', 'sui-po')))
      }, {
        label: _withCtx(({ label }) => [
          _createVNode(SooiPoIcon, { class: "ml-2" }),
          _createElementVNode("p", _hoisted_22, _toDisplayString(label), 1)
        ]),
        _: 1
      }, 8, ["isDisabled", "isEnabled", "label"]),
      _createVNode(CheckBox, {
        class: "pl-5",
        "input-id": "year-sha",
        isDisabled: !__props.hasDiagramDate,
        isEnabled: __props.toggles['year-sha'],
        label: _unref(t)('calculators.apartment-plan.actions.year-sha'),
        onToggle: _cache[12] || (_cache[12] = ($event: any) => (emit('toggle', 'year-sha')))
      }, {
        label: _withCtx(({ label }) => [
          _createVNode(YearShaIcon, { class: "ml-2" }),
          _createElementVNode("p", _hoisted_23, _toDisplayString(label), 1)
        ]),
        _: 1
      }, 8, ["isDisabled", "isEnabled", "label"]),
      _createVNode(CheckBox, {
        class: "pl-5",
        "input-id": "month-sha",
        isDisabled: !__props.hasDiagramDate,
        isEnabled: __props.toggles['month-sha'],
        label: _unref(t)('calculators.apartment-plan.actions.month-sha'),
        onToggle: _cache[13] || (_cache[13] = ($event: any) => (emit('toggle', 'month-sha')))
      }, {
        label: _withCtx(({ label }) => [
          _createVNode(MonthShaIcon, { class: "ml-2" }),
          _createElementVNode("p", _hoisted_24, _toDisplayString(label), 1),
          _createVNode(AppTooltip, {
            disabled: !__props.hasDiagramDate
          }, {
            trigger: _withCtx(() => [
              _createVNode(InfoSquareIcon, { class: "ml-auto !size-5" })
            ]),
            popper: _withCtx(() => [
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)("calculators.apartment-plan.info.month-sha")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["isDisabled", "isEnabled", "label"]),
      _createVNode(CheckBox, {
        class: "pl-5",
        "input-id": "noble-stars",
        isDisabled: !__props.hasDiagramDate,
        isEnabled: __props.toggles['noble-stars'],
        label: _unref(t)('calculators.apartment-plan.actions.noble-stars'),
        onToggle: _cache[15] || (_cache[15] = ($event: any) => (emit('toggle', 'noble-stars')))
      }, {
        label: _withCtx(({ label }) => [
          _createElementVNode("p", _hoisted_26, _toDisplayString(label), 1),
          _createVNode(InfoSquareIcon, {
            class: _normalizeClass(["ml-auto !size-5", { 'cursor-pointer': __props.hasDiagramDate }]),
            onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (openInfoModal('noble-stars')), ["prevent"]))
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["isDisabled", "isEnabled", "label"]),
      _createVNode(CheckBox, {
        class: "pl-5",
        "input-id": "current-stars",
        isDisabled: !__props.hasDiagramDate,
        isEnabled: __props.toggles['current-stars'],
        label: _unref(t)('calculators.apartment-plan.actions.current-stars'),
        onToggle: _cache[17] || (_cache[17] = ($event: any) => (emit('toggle', 'current-stars')))
      }, {
        label: _withCtx(({ label }) => [
          _createElementVNode("p", _hoisted_27, _toDisplayString(label), 1),
          _createVNode(InfoSquareIcon, {
            class: _normalizeClass(["ml-auto !size-5", { 'cursor-pointer': __props.hasDiagramDate }]),
            onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (openInfoModal('current-stars')), ["prevent"]))
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["isDisabled", "isEnabled", "label"]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.diagram-scale")), 1),
        _createVNode(CustomSlider, {
          "model-value": props.diagramScale,
          min: 0.1,
          max: 3,
          step: 0.01,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = (val) => emit('update:diagram-scale', val))
        }, null, 8, ["model-value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.mountains-group")), 1),
      _createVNode(CheckBox, {
        "input-id": "middle-12-mountains",
        label: _unref(t)('calculators.apartment-plan.actions.middle-12-mountains'),
        onToggle: _cache[19] || (_cache[19] = ($event: any) => (emit('toggle', 'middle-12-mountains')))
      }, null, 8, ["label"]),
      _createVNode(CheckBox, {
        "input-id": "border-12-mountains",
        label: _unref(t)('calculators.apartment-plan.actions.border-12-mountains'),
        onToggle: _cache[20] || (_cache[20] = ($event: any) => (emit('toggle', 'border-12-mountains')))
      }, null, 8, ["label"]),
      _createVNode(CheckBox, {
        "input-id": "move-mountains-labels",
        label: _unref(t)('calculators.apartment-plan.actions.move-mountains-labels'),
        onToggle: _cache[21] || (_cache[21] = ($event: any) => (emit('toggle', 'move-mountains-labels')))
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("button", {
          class: "w-[62px] h-9 rounded-[100px] border border-brown text-sm text-brown",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (emit('export-as-png')))
        }, " PNG "),
        _createElementVNode("button", {
          class: "w-[62px] h-9 rounded-[100px] border border-brown text-sm text-brown",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (emit('export-as-pdf')))
        }, " PDF ")
      ]),
      _createVNode(PrintButton, {
        "btn-classes": "size-9",
        onClick: _cache[24] || (_cache[24] = ($event: any) => (emit('print')))
      })
    ]),
    _createVNode(ModalComponent, {
      show: showInfoModal.value,
      onClose: _cache[25] || (_cache[25] = ($event: any) => (showInfoModal.value = false))
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(t)(`calculators.apartment-plan.actions.${modalType.value}`)), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(t)(`calculators.apartment-plan.info.${modalType.value}`)), 1)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})